(function ($) {

	/*
	 *  new_map
	 *
	 *  This function will render a Google Map onto the selected jQuery element
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$el (jQuery element)
	 *  @return	n/a
	 */

	function new_map($el) {

		// var
		var $markers = $el.find('.marker');


		// vars
		var args = {
			zoom: 12,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f0f6f8"
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f0f6f8"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#bfd9e2"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					featureType: 'poi.business',
					stylers: [{ visibility: 'off' }]
				},
				{
					featureType: 'transit',
					elementType: 'labels.icon',
					stylers: [{ visibility: 'off' }]
				}
			],
			disableDefaultUI: true
		};


		// create map
		var map = new google.maps.Map($el[0], args);


		// add a markers reference
		map.markers = [];


		// add markers
		$markers.each(function () {

			add_marker($(this), map);

		});


		// center map
		center_map(map);


		// return
		return map;

	}

	/*
	 *  add_marker
	 *
	 *  This function will add a marker to the selected Google Map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	$marker (jQuery element)
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function add_marker($marker, map) {

		// var
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

		// create marker
		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: new google.maps.MarkerImage($marker.attr('data-icon'))
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function () {

				infowindow.open(map, marker);

			});
		}

	}

	/*
	 *  center_map
	 *
	 *  This function will center the map, showing all markers attached to this map
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	4.3.0
	 *
	 *  @param	map (Google Map object)
	 *  @return	n/a
	 */

	function center_map(map) {

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {

			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

			bounds.extend(latlng);

		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
		}
		else {
			// fit to bounds
			map.fitBounds(bounds);
		}

	}

	/*
	 *  document ready
	 *
	 *  This function will render each map when the document is ready (page has loaded)
	 *
	 *  @type	function
	 *  @date	8/11/2013
	 *  @since	5.0.0
	 *
	 *  @param	n/a
	 *  @return	n/a
	 */
	// global var
	var map = null;

	$(document).ready(function () {

		$('#slider').slick({
			'dots': false,
			'arrows': false,
			'slide': '.slide',
			'autoplay': true,
			'autoplaySpeed': 5000
		});

		var hero_slider_duration = $('#hero-slider').data('duration');

		$('#hero-slider').slick({
			'dots': false,
			'arrows': false,
			'slide': '.slide',
			'autoplay': true,
			'autoplaySpeed': hero_slider_duration
		});

		var trackNum = $('.related-track-slider>div').length;
		$('.related-track-slider').slick({
			centerMode: true,
			centerPadding: '0',
			slidesToShow: (trackNum < 6 ? trackNum : 6),
			slidesToScroll: 1,
			swipeToSlide: true,
			prevArrow: $('.related-tracks .slider-arrow.slider-prev'),
			nextArrow: $('.related-tracks .slider-arrow.slider-next'),
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 767,
					settings: {
						centerPadding: '40px',
						slidesToShow: 3
					}
				},
				{
					breakpoint: 575,
					settings: {
						centerPadding: '40px',
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						centerPadding: '30px',
						slidesToShow: 1
					}
				}
			]
		});

		var carNum = $('.related-car-slider>div').length;
		$('.related-car-slider').slick({
			centerMode: true,
			centerPadding: '0',
			slidesToShow: (carNum < 4 ? carNum : 4),
			slidesToScroll: 1,
			swipeToSlide: true,
			prevArrow: $('.related-cars .slider-arrow.slider-prev'),
			nextArrow: $('.related-cars .slider-arrow.slider-next'),
			responsive: [
				{
					breakpoint: 767,
					settings: {
						centerPadding: '40px',
						slidesToShow: 3
					}
				},
				{
					breakpoint: 575,
					settings: {
						centerPadding: '40px',
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						centerPadding: '30px',
						slidesToShow: 1
					}
				}
			]
		});

		$('.supercar-slider .supercar-slider-outer').slick({
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: true,
			slidesToShow: 1,
			swipeToSlide: true,
			rtl: true,
			prevArrow: $('.supercar-slider .slider-arrow.slider-prev'),
			nextArrow: $('.supercar-slider .slider-arrow.slider-next')
		});

		$('.aph-slider .aph-slider-wrap').slick({
			slidesToShow: 1,
			swipeToSlide: true,
			prevArrow: $('.slider-controls .slider-control-prev'),
			nextArrow: $('.slider-controls .slider-control-next')
		});

		var addonNum = $('.addon-slider>div').length;
		$('.addon-slider').slick({
			arrows: false,
			centerMode: true,
			centerPadding: '0',
			slidesToShow: (addonNum < 4 ? addonNum : 4),
			swipeToSlide: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						centerPadding: '64px',
						slidesToShow: 1,
					}
				}
			]
		});

		var packageNum = $('.package-slider-outer>div').length;
		$('.package-slider-outer').slick({
			slidesToShow: (packageNum < 6 ? packageNum : 6),
			swipeToSlide: true,
			prevArrow: $('.package-slider, .experience-slider').find('.slider-arrow.slider-prev'),
			nextArrow: $('.package-slider, .experience-slider').find('.slider-arrow.slider-next'),
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: (packageNum < 3 ? packageNum : 3),
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerMode: true,
						centerPadding: '64px',
						slidesToShow: 1,
					}
				}
			]
		});

		if ($('section.intro').length) {
			introSizing()
			$('.intro-read-more').click(function (e) {
				var introsize = $('.intro-text h1').length ? $('.intro-text h1').outerHeight() : '6.4em;';
				if ($('.intro-text').hasClass('open')) {
					$('.intro-text').removeClass('open').css('max-height', introsize);
				} else {
					$('.intro-text').addClass('open').css('max-height', $('.intro-text-inner').outerHeight());
				}
			});

			function introSizing() {
				introsize = $('.intro-text h1').length ? $('.intro-text h1').outerHeight() : '6.4em;';
				if ($(window).width() <= 996) {
					$('.intro-text').removeClass('open').css('max-height', introsize);
				} else {
					$('.intro-text').css('max-height', '');
				}
			}

			$(window).resize(function () {
				introSizing()
			})
		}

		// enable bootstrap popovers
		$('[data-toggle="popover"]').popover()

		/**
		 * Activation
		 */
		$('.voucher-form-form').on('submit', function () {
			$(this).hide();
			$('#redeeming').show();
		});

		/**
		 * Booking flow
		 */
		$('#booking-flow .booking-step').first().css('max-height', ($(this).find('.step-head .container').height() + 60 + $(this).find('.step-content').height()));
		$('#booking-flow .step-title-wrap').click(function (e) {
			e.preventDefault();
			if (!$('#booking-flow form[disabled]').length) {
				var currTab = $('#booking-flow .booking-step.visible').attr('id');
				var newTab = $(this).parents('.booking-step').attr('id');
				if (newTab !== currTab) {
					$('#booking-flow .booking-step').css('max-height', '').removeClass('visible');
					var maxHeight = $(this).parents('.booking-step').find('.step-head .container').height() + 60 + $(this).parent('.step-title-bar').next('.step-content').height();
					var $newTab = $('#booking-flow #' + newTab)
					$newTab.css('max-height', maxHeight).addClass('visible');
					$newTab.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
						function () {
							var page = $('html, body')
							page.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function () {
								page.stop()
							})

							page.delay(200).animate({
								scrollTop: $newTab.offset().top - 100
							}, 1000, function () {
								page.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
							})
						}
					);
				}
			}
		});

		$('#booking-flow .step-content-head .content-back button').click(function (e) {
			e.preventDefault();
			$(this).parents('.booking-step').css('max-height', '').removeClass('visible').prev();
			var $prevStep = $(this).parents('.booking-step').prev()
			var maxHeight = $prevStep.find('.step-head .container').height() + 60 + $prevStep.find('.step-content').height();
			$prevStep.css('max-height', maxHeight).addClass('visible');
			$prevStep.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
				function () {
					var page = $('html, body')
					page.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function () {
						page.stop()
					})

					page.delay(200).animate({
						scrollTop: $newTab.offset().top - 100
					}, 1000, function () {
						page.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
					})
				}
			);
		})

		$('#booking-flow .car-selection-check').change(function () {
			var maxCars = parseInt($('#booking-flow input[name=num-cars]').val())
			if ($('input[name^=car-]:checked').length == maxCars) {
				$('.cars-selection-error').removeClass('d-block');
				$('#booking-flow #booking-flow-3 .step-title-wrap').trigger('click');
			}
			if ($('input[name^=car-]:checked').length > maxCars) {
				$(this).prop('checked', false);
				alert('For this experience you can choose up to ' + maxCars + ' cars. Please remove some cars before adding new ones, choose an experience with more, or contact us.');
			}

			var number_premium_cars = $('.premium input[name^=car-]:checked').length;
			$('#booking-flow input[name^=addon-]').not('.already-added').each(function () {
				var addon_premium_car_price = parseFloat($(this).parents('.addon-wrap').data('premium_car_price'));
				if (addon_premium_car_price > 0) {
					var addon_price = 0;
					addon_price += parseFloat($(this).parents('.addon-wrap').data('price'));
					addon_price += addon_premium_car_price * number_premium_cars;
					$(this).parents('.addon-wrap').find('.addon-price').html(addon_price);
				}
			});
		})

		$('.booking-step-continue').click(function (e) {
			e.preventDefault();
			$('#booking-flow #booking-flow-' + $(this).data('next_step_id') + ' .step-title-wrap').trigger('click');
		});

		$('#booking-flow .step-content-head .content-info').click(function (e) {
			e.preventDefault();
		})

		$('#booking-flow .addon-selection-check').change(function () {
			if ($(this).is(':checked')) {
				$(this).siblings('.addon-selection').find('.addon-button').text('Selected');
			} else {
				$(this).siblings('.addon-selection').find('.addon-button').text('Upgrade');
			}
		})

		$('#voucher-box .addon-selection-check').change(function () {
			if ($(this).is(':checked')) {
				$(this).siblings('.addon-selection').text('UPGRADED');
			} else {
				$(this).siblings('.addon-selection').text('UPGRADE');
			}
		})

		$('#booking-flow select, #booking-flow input').change(function () {
			bookingPriceUpdate()
		})

		$('#voucher-box select, #voucher-box input').change(function () {
			voucherPriceUpdate()
		})

		$('#voucher-box select, #voucher-box select').change(function () {
			voucherPriceUpdate()
		})

		$('#booking-flow form').submit(function (event) {
			if ($(this)[0].checkValidity() === false) {
				event.preventDefault();
				event.stopPropagation();
				if ($('#booking-flow #booking-flow-1').find(':invalid').length) {
					$('#booking-flow #booking-flow-1 .step-title-wrap').trigger('click');
				}
			} else {
				var maxCars = parseInt($('#booking-flow input[name=num-cars]').val());
				var force_num_cars = parseInt($('#booking-flow input[name=force-num-cars]').val());
				if (force_num_cars > 0 && maxCars > 0 && $('input[name^=car-]:checked').length < maxCars) {
					event.preventDefault();
					event.stopPropagation();
					$('#booking-flow #booking-flow-2 .step-title-wrap').trigger('click');
					$('.cars-selection-error').addClass('d-block');
				}
			}
			$(this).addClass('was-validated');
		});

		function bookingPriceUpdate() {
			var price = parseFloat($('#booking-flow input[name=base-price]').val());
			var track_premium = $('#booking-flow #track-selection').find(':selected').data('premium_price');
			var number_premium_cars = $('.premium input[name^=car-]:checked').length;
			var number_included_premium_cars = parseInt($('#booking-flow input[name=number_included_premium_cars]').val());
			if (track_premium > 0) {
				price += track_premium;
			}
			var session_premium = $('#booking-flow #session-selection').find(':selected').data('premium_price');
			if (session_premium > 0) {
				price += session_premium;
			}
			var premium_selected_count = 0;
			$('#booking-flow .premium input[name^=car-]:checked').each(function () {
				premium_selected_count++;
				if (premium_selected_count > number_included_premium_cars) {
					price += parseFloat($(this).parents('.col-car').data('price'));
				}
			})

			$('#booking-flow input[name^=addon-]:checked').each(function () {
				price += parseFloat($(this).parents('.addon-wrap').data('price'));
				price += parseFloat($(this).parents('.addon-wrap').data('premium_car_price')) * number_premium_cars;
			})

			if (price > 0) {
				var display_price = currencyFormat(price);
			} else {
				var display_price = '';
			}
			$('#booking-flow .step-head .price').text(display_price);
		}

		function voucherPriceUpdate() {
			var price = parseFloat($('#voucher-box input[name=base-price]').val());

			var delivery = parseFloat($('#voucher-box #voucher-type-selection').find(':selected').data('gbp'));
			price += delivery ? delivery : 0;

			$('#voucher-box input[name^=addon-]:checked').each(function () {
				price += parseFloat($(this).parents('.addon-wrap').data('price'));
			})

			var quantity = $('#voucher-box #item_quantity').find(':selected').val();
			price *= quantity ? quantity : 1;

			$('#voucher-box .price').text(currencyFormat(price));
		}

		function bookingFlowResize() {
			$('#booking-flow .booking-step').each(function () {
				if ($(this).hasClass('visible')) {
					var maxHeight = $(this).find('.step-head .container').height() + 60 + $(this).find('.step-content').height();
					$(this).css('max-height', maxHeight)
				}
			});
		}

		if ($('#booking-flow').length) {
			$(window).resize(function () {
				bookingFlowResize();
			})
		}

		function currencyFormat(amount) {
			return GEXP.currency_symbol + (parseFloat(amount)).toFixed(2);
		}

		var scrollwidth = window.innerWidth - document.documentElement.clientWidth
		var eventCal
		$('#upcoming-events-button').fancybox({
			touch: false,
			afterShow: function () {
				initEventCal();
			},
			afterClose: function () {
				if (eventCal) {
					eventCal.clear();
				}
				$("#fancybox-style-noscroll-padding").remove();
			},
			onInit: function () {
				$("head").append(
					'<style id="fancybox-style-noscroll-padding" type="text/css">.compensate-for-scrollbar-padding {padding-right:' +
					scrollwidth +
					"px;}</style>"
				);
			}
		})



		function initEventCal() {
			var lastDate = new Date(Math.max.apply(null, Object.keys(geEventDates).map(function (e) {
				return new Date(e);
			})));

			var maxDate = isNaN(lastDate) ?
				new Date().setDate(new Date().getDate() + 1) :
				lastDate;

			var firstDate = new Date(Math.min.apply(null, Object.keys(geEventDates).map(function (e) {
				return new Date(e);
			})));

			var minDate = isNaN(firstDate) ?
				'today' :
				firstDate;

			var dates = Object.keys(geEventDates).length ?
				Object.keys(geEventDates) :
				[function () { return false; }];

			if (!eventCal) {
				eventCal = $('#calendar .placeholder').flatpickr({
					inline: true,
					minDate: minDate,
					maxDate: maxDate,
					showMonths: 1,
					enable: dates,
					disableMobile: "true",
					onChange: function (date, str, inst) {
						var contents = '';
						if (date.length) {
							for (i = 0; i < geEventDates[str].length; i++) {
								contents += '<div class="event"><div class="date">' + flatpickr.formatDate(date[0], 'l J F Y') + '</div><div class="location">' + geEventDates[str][i] + '</div></div>';
							}
						}
						$('#calendar .calendar-events').html(contents)
					},
					locale: {
						weekdays: {
							shorthand: ["S", "M", "T", "W", "T", "F", "S"],
							longhand: [
								"Sunday",
								"Monday",
								"Tuesday",
								"Wednesday",
								"Thursday",
								"Friday",
								"Saturday",
							]
						}
					}
				})

				eventCaledarResize($(window), eventCal);
				$(window).on('resize', function () {
					eventCaledarResize($(this), eventCal)
				})
			}
		}

		function eventCaledarResize($el, cal) {
			var width = $el.width()
			if (cal.selectedDates.length) {
				cal.clear()
			}
			if (width >= 1200 && cal.config.showMonths !== 3) {
				cal.set('showMonths', 3)
			}
			if (width < 1200 && width >= 768 && cal.config.showMonths !== 2) {
				cal.set('showMonths', 2)
			}
			if (width < 768 && cal.config.showMonths !== 1) {
				cal.set('showMonths', 1)
				$('.flatpickr-calendar').css('width', '')
			}
		}

		// track page auto-open directions
		if (window.location.hash && window.location.hash.substring(1) === 'directions') {
			$("#get-directions-link").trigger('click');
		}

		var slick_mobile_width = 768;
		function slickify() {
			$('.slick-mobile').slick({
				'arrows': false,
				'centerMode': true,
				'centerPadding': '20%',
				'mobileFirst': true,
				'slide': '.slide',
				'responsive': [
					{
						breakpoint: slick_mobile_width,
						settings: "unslick"
					}
				]
			});
		}
		slickify();
		$(window).resize(function () {
			var $windowWidth = $(window).width();
			if ($windowWidth < slick_mobile_width) {
				slickify();
			}
		});

		$('.main-navigation ul li').focusin(function () {
			$(this).addClass('focus')
		})

		$('.main-navigation ul li').focusout(function () {
			$(this).removeClass('focus')
		})

		function toggleMenu() {
			$('#site-navigation').toggleClass('toggled');
			$('body').toggleClass('menu-open');
			$('#header-navigation .menu-item-has-children>a').removeClass('active').next().slideUp();
			$('#nav-toggle').attr('aria-expanded', ($('#nav-toggle').attr('aria-expanded') === 'false'));
		}

		$('#nav-toggle').click(function () {
			toggleMenu()
		});

		$('#header-navigation .menu-item-has-children>a').click(function (e) {
			if ($('#site-navigation').hasClass('toggled')) {
				e.preventDefault()
				var dir = $(this).hasClass('active')
				if (dir) {
					$(this).next().slideUp()
				} else {
					$(this).next().slideDown()
					$('#header-navigation .menu-item-has-children>a').not(this).removeClass('active').next().slideUp()
				}
				$(this).toggleClass('active')
			}
		})

		$('#header-navigation .menu-item-has-children>a').doubleTapToGo();

		$(document).click(function (event) {
			if (!$(event.target).closest('.menu-wrapper, #nav-toggle').length && $('#site-navigation').hasClass('toggled')) {
				toggleMenu()
			}
		})

		$('.map').each(function () {

			// create map
			map = new_map($(this));

		});

		$('#stripe-submit-order').submit(function (e) {
			e.preventDefault();

			if ($('#cb_confirm').prop('checked')) {
				stripe.redirectToCheckout({
					sessionId: $(this).data('session')
				});
			}
		})

	});

	function matchHeight() {
		var maxHeight = 0;
		$('.match-height').each(function () {
			$(this).height('auto');
			if ($(this).height() > maxHeight) {
				maxHeight = $(this).height();
			}
		});
		$('.match-height').each(function () {
			$(this).height(maxHeight);
		});
	}

	matchHeight();

	$(window).resize(function () {
		headerHeight = $('header').height();
		menuPosition = $('#site-branding').position().top;

		matchHeight();
	});

	var headerHeight = $('header').height();
	var menuPosition = $('#site-branding').position().top;

	$(window).scroll(function (event) {
		var scroll = $(window).scrollTop();
		if (scroll > menuPosition) {
			$('header').addClass('scrolled');
			//$('body').css('margin-top', headerHeight);
		} else {
			$('header').removeClass('scrolled');
			//$('body').css('margin-top', 0);
		}
		if (scroll < 700) {
			$('#slider .slide').css('background-position', '50% ' + (scroll / 4) + 'px');
		}
	});

	$('.staff-event-modal').click(function (event) {
		$('#staffEventModal .modal-title').html($(this).data('staff_event_title'));
		$('#staffEventModal #staff_event_id').val($(this).data('staff_event_id'));
	});

	$('#staffEventModal .modal-form').submit(function (event) {
		var role_checked = false;

		$('.staff-role', this).each(function () {
			if ($(this).prop('checked')) {
				role_checked = true;
			}
		});

		if (!role_checked) {
			event.preventDefault();
			$('#staffEventModal .response-message').html('Error: Please select at least one role');
		}
	});

	$('.filter-select').change(function (event) {
		var filter_by = $(':selected', this).attr('id');
		var filter_group = $(this).closest('.filter-group');

		$('.filter-item', filter_group).hide();
		$('.filter-item.' + filter_by, filter_group).show();
	});
	$('.filter-select').trigger('change');


	var cookieConsent = {
		'config': {
			'cookieName': 'cookie_consent',
			'cookieValue': 'accepted',
			'cookieExpiry': 90
		},
		'init': function () {
			if (!cookieConsent.checkCookie(cookieConsent.config.cookieName)) {
				$('#cookie-consent').addClass('show');
				$('#cookie-accept').click(function () {
					cookieConsent.setCookie(cookieConsent.config.cookieName, cookieConsent.config.cookieValue, cookieConsent.config.cookieExpiry);
					$('#cookie-consent').removeClass('show');
				});
			}
		},
		'setCookie': function (cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},
		'checkCookie': function (cname) {
			return document.cookie.indexOf(cname + '=') > -1;
		}
	};

	cookieConsent.init();

	var siteNotice = {
		'config': {
			'cookieName': 'site_notice_' + GEXP.site_notice_version,
			'cookieValue': 'accepted',
			'cookieExpiry': 30
		},
		'init': function () {
			if (!siteNotice.checkCookie(siteNotice.config.cookieName)) {
				$('#site-notice').addClass('show');
				$('#notice-accept').click(function () {
					siteNotice.setCookie(siteNotice.config.cookieName, siteNotice.config.cookieValue, siteNotice.config.cookieExpiry);
					$('#site-notice').removeClass('show');
				});
			}
		},
		'setCookie': function (cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},
		'checkCookie': function (cname) {
			return document.cookie.indexOf(cname + '=') > -1;
		}
	};

	siteNotice.init();

	$(document).ready(function () {
		if ($(".branded-products")[0]) {
			gform.addFilter('gform_product_total', function (total, formId) {
				// do something with the total
				let element = '<h4>Total</h4><label>£' + total.toFixed(2) + '</label>';
				$('#total-copy').html(element)
				return total;
			});

			$('#gotopayment').click(function () {
				$([document.documentElement, document.body]).animate({
					scrollTop: $(".gfield--type-address").offset().top - 150
				}, 2000);
			})

			$('.gfield_quantity .ginput_container_number').click(function () {
				let oldQty = $(this).find('input').val();
				let btnText = 'Add to Cart';
				let newQty = 0;
				if (oldQty > 0) {
					newQty = Number(oldQty) - 1;
				}

				newQty = newQty > 0 ? newQty : 0;
				if (newQty) {
					btnText = 'Add to Cart' + '<span>' + newQty + '</span>';
				}
				$(this).siblings('.gform-field-label').html(btnText);
				$(this).find('input').val(newQty).trigger('change');
			})

			$('.gfield_quantity .gform-field-label').click(function (e) {
				e.preventDefault();
				let oldQty = $(this).siblings('.ginput_container_number').find('input').val();
				let newQty = Number(oldQty) + 1;
				$(this).html('Add to Cart' + '<span>' + newQty + '</span>');
				$(this).siblings('.ginput_container_number').find('input').val(newQty).trigger('change');
			})
		}

		$(document).on('gform_confirmation_loaded', function(event, formId) {
			$('.content-area').find('.total-wrapper').hide();
		})

	})

})(jQuery);
